module.exports = __webpack_public_path__ + "img/outStore.a8cc9e30.png";